<template>
  <div style="display: flex">
    <div
      class="monitoring-target__detail"
      :style="{ cursor: isRhelCoreOs || item.checkAsg ? 'default' : 'pointer' }"
      @click.stop="customClick"
      :class="{ 'no-asg-target': !item.checkAsg && !isRhelCoreOs }"
    >
      <c-asg v-if="item.checkAsg" />
      <template v-else>
        <a v-if="!isRhelCoreOs" data-target="cell" class="target__detail">
          <lego-icon without-pointer iconType="picto" icon="detail_view" :size="16" />
        </a>
        <div v-else style="width: 36px; height: 20px"></div>
      </template>
      <div v-if="$slots.default">
        <slot />
      </div>
      <div v-else class="monitoring-target__value" v-lego-tooltip:ellipsis="value">
        <span>{{ value }}</span>
      </div>
    </div>
  </div>
</template>
<script setup>
import { computed, getCurrentInstance, ref } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  item: {
    type: Object,
    required: true
  },
  value: {
    type: [String, Object],
    default: ''
  },
  iIdx: {
    type: Number
  },
  activeTab: {
    type: String,
    default: 'performance'
  },
  coreOs: {
    type: String,
    default: ''
  },
  productTypeCode: {
    type: String,
    default: 'VM'
  }
});
const { $util, $const, $modal } = getCurrentInstance().appContext.config.globalProperties;
const { t } = useI18n();
const $store = useStore();
const emit = defineEmits(['showTargetDetail', 'resetSelected']);
const isRhelCoreOs = computed(() => {
  if (props.item.checkDisabled && props.activeTab === 'performance') return true;
  return $util.isRhelCoreOs(props.item[props.coreOs]);
});
const customClick = () => {
  if (isRhelCoreOs.value || props.item.checkAsg) return;
  const tabs = { performance: 1, log: 2, event: 3 };
  const productId = props.item['productId'] || props.item['productSq'];
  const listDataCheckAuth = [
    {
      productResourceId: props.item.productId || props.item.productSq,
      productName: props.item.productName
    }
  ];
  const productTypeCode = props.item['productTypeCode'] || props.productTypeCode;
  if (!productId || !productTypeCode) {
    $modal.open({
      rootId: 'app',
      type: 'alert',
      title: t('title.notice'),
      message: t('message.checkTargetDetail'),
      action: () => {}
    });
    return;
  }
  const payload = {
    productTypeCode,
    params: {
      productId
    },
    listDataCheckAuth
  };

  $store.dispatch('authStore/checkProductDetail', payload).then((res) => {
    if (res && res.type !== $const.AuthorizationResult.ALLOW) {
      emit('resetSelected', {
        productResourceId: props.item['productResourceId'],
        productName: props.item['productName'],
        productId
      });
      return;
    }
    emit('showTargetDetail', {
      item: props.item,
      productItem: {
        productTypeCode,
        productId
      },
      activeTab: tabs[props.activeTab]
    });
  });
};
</script>
<style lang="scss" scoped>
.monitoring-target__detail {
  display: flex;
  flex-flow: nowrap;
  gap: 4px;
  width: inherit;
  max-width: 100%;
  min-height: 30px;
  align-items: center;

  .target__detail {
    display: flex;
    width: 36px;
    justify-content: center;
  }

  .monitoring-target__value {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    flex: 1;
    margin-left: 2px;
  }
  :deep(.badge-asg .lego-badge) {
    margin-right: 0;
  }
  &.no-asg-target {
    .target__detail {
      &:hover {
        :deep(path) {
          fill: #2e3138;
        }
      }
    }
    .monitoring-target__value {
      &:hover {
        color: #2c59d9;
        text-decoration: underline;
      }
    }
  }
}
</style>
